import React, { useState, useEffect } from 'react';
import { Formik } from "formik";
import { Form, Row, Col, Button } from "react-bootstrap";
import "../../../../assets/css/cms/poll.css"
import DataTable from "react-data-table-component";
import { useSelector, useDispatch } from 'react-redux';
import Select from "react-select";
import { CUSTOM_STYLE_DATA_TABLE, DEVICE_TYPE, DEGREE_STATUS} from "../../../../constants/cms";
import { getCommentModerationFilterAction, getCommentModerationListAction
} from "../../../../../store/actions/cms/pollAction";
import TextField from "@mui/material/TextField";
import DesktopDatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import Box from '@mui/material/Box'
import { format } from 'date-fns';
import Tooltip from "@mui/material/Tooltip";
import { clearMessage } from "../../../../../store/slices/pollSlice";
import { FaSearch } from "react-icons/fa";
import "../../../../assets/css/cms/commentModeration.css";
import { useLocation } from 'react-router-dom';


const CommentModeration = () => {
  const location = useLocation();
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [tableCustomData, setTableCustomData] = useState([]);
  const [perPage, setPerPage] = useState(20);
  const [totalRows, setTotalRows] = useState(0);
  const dispatch = useDispatch();
  const [debounceState, setDebounceState] = useState(false)
  const [formikValues, setFormikValues] = useState({})
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  // const {
  //   pollTitleFilterData, pollStatusFilterData, pollDeviceFilterData, pollsListData, deletePollsError, deletePollsDataSuccess,
  //   pollPageTypeFilterData, pollEntityTypeFilterData, pollEntityNameFilterData, pollsListLoading, message
  // } = useSelector((state) => state?.pollCreationReducer)
  const {
    commentModerationFilterData, commentModerationListData, message, commentModerationFilterLoading
  } = useSelector((state) => state?.commentModerationReducer)

  // useEffect(() => {
  //   dispatch(getCommentModerationListAction());
  // }, [])

  useEffect(() => {
    if (commentModerationListData) {
      setTableData(commentModerationListData?.results);
      setTotalRows(commentModerationListData?.totalRows);
    }
  }, [commentModerationListData])

  useEffect(() => {
    // Check if all values are null or undefined
    // const isValuesEmpty = Object.values(values).every((item) => item === null || item === undefined);
    const isFormikValuesEmpty = Object.values(formikValues)?.every((item) => item === null || item === undefined);
    const isFiltersEmpty = isFormikValuesEmpty && !dateFrom && !dateTo;
    if (isFiltersEmpty) {
      dispatch(getCommentModerationFilterAction());
    }
  }, [formikValues, dateFrom, dateTo])


  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    let params = {};
    params.page = page;
    params.itemsOnPage = newPerPage;
    params.poll_id = formikValues?.polls_title?.id;
    params.status = formikValues?.status?.id;
    params.device = formikValues?.device_type?.id;
    if (dateFrom) params.created_from = format(new Date(dateFrom), 'yyyy-MM-dd');
    if (dateTo) params.created_to = format(new Date(dateTo), 'yyyy-MM-dd');
    dispatch(getCommentModerationListAction(params));
    setPerPage(newPerPage);
  };


  useEffect(() => {
    if (currentPage) {
      let params = {};
      params.page = currentPage;
      params.itemsOnPage = perPage;
      params.poll_id = formikValues?.polls_title?.id;
      params.status = formikValues?.status?.id;
      params.device = formikValues?.device_type?.id;
      if (dateFrom) params.created_from = format(new Date(dateFrom), 'yyyy-MM-dd');
      if (dateTo) params.created_to = format(new Date(dateTo), 'yyyy-MM-dd');
      // dispatching list API
      dispatch(getCommentModerationListAction(params))

      setTableCustomData([
        {
          name: "Comments",
          selector: (row) => row.comment,
          maxWidth: "250px !important",
          cell: (row) => (
            <Tooltip
              title={row.comment?.length > 30 ? row.comment : ""}
              arrow
              placement="top"
            >
              <span>
                {row.comment?.length > 30 ? `${row.comment.substring(0, 30)}...` : row.comment}
              </span>
            </Tooltip>
          ),
        },
        {
          name: "User Mail ID",
          selector: (row) => row.user_email,
          maxWidth: "250px",
        },
        {
          name: "Date Created",
          selector: (row) => {
            const date = row?.created_at ? new Date(row.created_at) : null;
            return date && !isNaN(date.getTime()) ? format(date, 'MM/dd/yyyy') : "N/A";
          },
        },
        {
          name: "Date Modified",
          selector: (row) => {
            const date = row?.updated_at ? new Date(row.updated_at) : null;
            return date && !isNaN(date.getTime()) ? format(date, 'MM/dd/yyyy') : "N/A";
          },
        },
        {
          name: "Device",
          selector: (row) => row.device,
          cell: (row) => {
            let deviceType = "Unknown";
            switch (row.device) {
              case 1:
                deviceType = "Web";
                break;
              case 2:
                deviceType = "Mobile";
                break;
              case 3:
                deviceType = "App";
                break;
            }
            return <span style={{ fontWeight: 'bold' }}>{deviceType}</span>;
          }
        },        
        {
          name: "Publishing Status",
          selector: (row) => (row.status === 1 ? "Published" : "Unpublished"),
          cell: (row) => {
            const isPublished = row.status === 1;
            return (
              <button
                className='publishing_status'
                style={{
                  color: isPublished ? 'green' : 'red',
                  background: isPublished ? '#ecfdf5' : '#fef2f2',
                }}
              >
                {isPublished ? 'Published' : 'Unpublished'}
              </button>
            );
          }
        },        
        {
          name: "Action",
          selector: (row) => row.action,
          cell: (row, index, column, id) => (
            <div>
              <a href={`/cms/polls/manage-comment-moderation/${row.id}`}>
                {" "}
                <span className={"edit_icon"}>
                  {/* <RiEdit2Line /> */}Edit
                </span>
              </a>
            </div>
          ),
          allowOverflow: true,
          center: "true",
        },
      ]);
    }
  }, [currentPage]);

  useEffect(() => {
    if (message) {
      let params = {};
      params.page = currentPage;
      params.itemsOnPage = perPage;
      params.poll_id = formikValues?.polls_title?.id;
      params.status = formikValues?.status?.id;
      params.device = formikValues?.device_type?.id;
      if (dateFrom) params.created_from = format(new Date(dateFrom), 'yyyy-MM-dd');
      if (dateTo) params.created_to = format(new Date(dateTo), 'yyyy-MM-dd');
      setTimeout(() => {
        if (message) {
          dispatch(clearMessage());
        } else {
          dispatch(clearMessage());
          dispatch(getCommentModerationListAction(params));
        }
      }, 3000);
    }
  }, [message]);

  useEffect(() => {
    
  if(formikValues){
      let params = {};
      params.page = currentPage;
      params.itemsOnPage = perPage;
      params.poll_id = formikValues?.polls_title?.id;
      params.status = formikValues?.status?.id;
      params.device = formikValues?.device_type?.id;
      if (dateFrom) params.created_from = format(new Date(dateFrom), 'yyyy-MM-dd');
      if (dateTo) params.created_to = format(new Date(dateTo), 'yyyy-MM-dd');
      setCurrentPage(1); // Reset to page 1
      setResetPaginationToggle(!resetPaginationToggle); // Toggle to reset pagination
      // if(!Object.keys(values)?.length !=0 || dateFrom !=null || dateTo!=null)
      dispatch(getCommentModerationListAction(params))
    }
  }, [formikValues]);

  useEffect(() => {
    let params = {};
    params.page = currentPage;
    params.itemsOnPage = perPage;
    params.poll_id = formikValues?.polls_title?.id;
    params.status = formikValues?.status?.id;
    params.device = formikValues?.device_type?.id;
    if (dateFrom) params.created_from = format(new Date(dateFrom), 'yyyy-MM-dd');
    if (dateTo) params.created_to = format(new Date(dateTo), 'yyyy-MM-dd');
    dispatch(getCommentModerationListAction(params));
  }, [dateFrom, dateTo]);


  const updateAndStoreFilters = (updatedValues, dateFromValue = dateFrom, dateToValue = dateTo) => {
    const filterData = {
      ...updatedValues,
      dateFrom: dateFromValue,
      dateTo: dateToValue,
    };
    localStorage.setItem("commentModerationFilters", JSON.stringify(filterData));
    setFormikValues(updatedValues);
  };
  
  const handleDateFromChange = (value) => {
    const isoDate = value ? value.toISOString() : null;
    setDateFrom(isoDate);
    updateAndStoreFilters(formikValues, isoDate, dateTo);
  };
  
  const handleDateToChange = (value) => {
    const isoDate = value ? value.toISOString() : null;
    setDateTo(isoDate);
    updateAndStoreFilters(formikValues, dateFrom, isoDate);
  };
  
  useEffect(() => {
    const pathname = location.pathname;
  
    if (pathname.includes("/comment-moderation")) {
      const savedFilters = localStorage.getItem("commentModerationFilters");
      if (savedFilters) {
        const parsed = JSON.parse(savedFilters);
        if (parsed?.polls_title?.id) {
          setFormikValues({
            polls_title: parsed?.polls_title,
            status: parsed?.status || null,
            device_type: parsed?.device_type || null,
          });
          setDateFrom(parsed?.dateFrom || null);
          setDateTo(parsed?.dateTo || null);
        }
      }
    } else {
      localStorage.removeItem("commentModerationFilters");
    }
  }, [location.pathname]);  
  
  return (
    <div style={{ backgroundColor: '##edeef2', minHeight: '100vh' }}>

      {/* breadcrumb */}
      {/* <div className={"custom_breadcrumb"}>
        <ul className={"custom_breadcrumb_ul"}>
          <li className={"custom_breadcrumb_list"}>
            <Link to="/cms/">
              <a className={"sub_nan_anchor"}>Home</a>
            </Link>
          </li>
          <li className={"custom_breadcrumb_list"}>
            <span>
              <FiChevronRight />
            </span>
          </li>
          <li className={`${"custom_breadcrumb_list"} ${"custom_breadcrumb_list_active"}`}>
            Comment Moderation
          </li>
        </ul>
      </div> */}

      {/* Counter Cards */}

      <div className={"examfilter"}>

        <h3 className='mt-2 mb-3'>Poll Comments Moderation</h3>

        {/* filter form */}

        <Formik
         initialValues={formikValues}
          enableReinitialize
          validate={(values) => {
            const errors = {};

            return errors;
          }}
          onSubmit={(values) => {
            // submit(values);
          }}
        >
          {({
            values,
            handleSubmit,
            setFieldValue,
            resetForm,
          }) => {

            const handleSearchTitle = (query) => {
              let inDebounce = debounceState;
              clearTimeout(inDebounce);
              inDebounce = setTimeout(() => {
                if (typeof query === 'string') {
                  const trimmedQuery = query.trim();
                  const params = {};

                  // If empty, load default filter options
                  if (trimmedQuery.length === 0) {
                    dispatch(getCommentModerationFilterAction());
                  } else if (trimmedQuery.length > 1) {
                    params.term = trimmedQuery;
                    dispatch(getCommentModerationFilterAction(params));
                  }
                }
              }, 500);
              setDebounceState(inDebounce);
            };
           
            const handleOnChange = (field, obj) => {
              setFieldValue(field, obj);
              const updatedValues = { ...values, [field]: obj };
              setFormikValues(updatedValues);
              updateAndStoreFilters(updatedValues);
            }

            const clearFilter = () => {
              setFormikValues({});
              setFieldValue("polls_title", null); 
              setFieldValue("status", null);
              setFieldValue("device_type", null);
              setDateFrom(null); 
              setDateTo(null);
              localStorage.removeItem("commentModerationFilters");
              setTableData([]); 
            }
            const handleClear = () => {
              resetForm();
              clearFilter();
              setTableData([]);
              localStorage.removeItem("commentModerationFilters"); 
            }

            return (
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={11} className='mb-4'>
                    <Form.Group>
                    <Select
                      placeholder={
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <FaSearch style={{ marginRight: "8px" }} /> Search or Select Poll Title
                        </div>
                      }
                      name="polls_title"
                      isClearable={true}
                      isSearchable={true}
                      options={commentModerationFilterData}
                      getOptionLabel={(option) => option["title"]}
                      getOptionValue={(option) => option["id"]}
                      value={values?.polls_title || null}
                      onChange={(obj) => {
                        handleOnChange("polls_title", obj);
                      }}
                      onInputChange={(query) => {
                          handleSearchTitle(query);
                      }}
                      isDisabled={values?.polls_title}
                      noOptionsMessage={() => "No polls found with the entered title."}
                    />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className='mt-4'>
                  <Col className='mb-4'>
                    <Form.Group>
                      <Select
                        placeholder="Publishing Status"
                        name="status"
                        isClearable={true}
                        isSearchable={true}
                        options={DEGREE_STATUS}
                        getOptionLabel={(option) => option["value"]}
                        getOptionValue={(option) => option["id"]}
                        onChange={(obj) => handleOnChange("status", obj)}
                        value={values?.status || null}
                        isDisabled={!values?.polls_title}
                      />
                    </Form.Group>
                  </Col>
                  <Col className='mb-4'>
                    <Form.Group>
                      <Select
                        placeholder="Device"
                        name="device_type"
                        isClearable={true}
                        isSearchable={true}
                        options={DEVICE_TYPE}
                        getOptionLabel={(option) => option["value"]}
                        getOptionValue={(option) => option["id"]}
                        onChange={(obj) => handleOnChange("device_type", obj)}
                        value={values?.device_type || null}
                        isDisabled={!values?.polls_title}
                      />
                    </Form.Group>
                  </Col>
                  <Col className='mb-4'>
                    <Form.Group className="mb-3 date_input" controlId="startDate">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                          disabled={!values?.polls_title}
                          label="Custom input"
                          value={dateFrom}
                          maxDate={(dateTo != null && dateTo != undefined) ? new Date(dateTo) : undefined}
                          onChange={(sValue) => handleDateFromChange(sValue)}
                          renderInput={({ inputRef, inputProps, InputProps,
                          }) => (
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Form.Control
                                ref={inputRef}
                                {...inputProps}
                                className={"input_pd"}
                                placeholder='Date Created From'
                                value={dateFrom ? format(new Date(dateFrom), 'dd-MM-yyyy') : ''}
                                disabled={!values?.polls_title}
                                onFocus={(e) => {
                                  if (!values?.polls_title) {
                                    e.preventDefault();
                                    e.target.blur(); // Prevents calendar on keyboard or auto-focus
                                  }
                                }}
                                onMouseDown={(e) => {
                                  if (!values?.polls_title) {
                                    e.preventDefault(); // Blocks mouse-based popup
                                  }
                                }}
                              />
                              {InputProps?.endAdornment}
                              {dateFrom && (
                                <Button
                                variant="link"
                                onClick={() => {
                                  setDateFrom(null);
                                  updateAndStoreFilters(formikValues, null, dateTo); 
                                }}
                                className={"cross-button position-absolute"}
                              >
                                &#x2716;
                              </Button>                              
                              )}
                            </Box>
                          )}
                        />
                      </LocalizationProvider>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3 date_input" controlId="startDate">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                          disabled={!values?.polls_title}
                          label="Custom input"
                          value={dateTo}
                          minDate={dateFrom && new Date(dateFrom)}
                          onChange={(eValue) => handleDateToChange(eValue)}
                          renderInput={({ inputRef, inputProps, InputProps, }) => (
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Form.Control
                                ref={inputRef}
                                {...inputProps}
                                className={"input_pd"}
                                placeholder='Date Created To'
                                value={dateTo ? format(new Date(dateTo), 'dd-MM-yyyy') : ''}
                                disabled={!values?.polls_title}
                                onFocus={(e) => {
                                  if (!values?.polls_title) {
                                    e.preventDefault();
                                    e.target.blur(); 
                                  }
                                }}
                                onMouseDown={(e) => {
                                  if (!values?.polls_title) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                              {InputProps?.endAdornment}
                              {dateTo && (
                                <Button
                                variant="link"
                                onClick={() => {
                                  setDateTo(null);
                                  updateAndStoreFilters(formikValues, dateFrom, null);
                                }}
                                className={"cross-button position-absolute"}
                              >
                                &#x2716;
                              </Button>                              
                              )}
                            </Box>
                          )}
                        />
                      </LocalizationProvider>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <div style={{ position: 'relative', right: '0px', left: '32%', display: 'inline-block' }}>
                        <button
                          className={`reset_button`}
                          type="button"
                          onClick={handleClear}
                        >
                          Reset
                        </button>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>
      </div>
      {/* Listing Table */}
      {formikValues?.polls_title?.id &&
        <div className={" my-5 polls_table_list_cover"}>
          <DataTable
            columns={tableCustomData}
            customStyles={CUSTOM_STYLE_DATA_TABLE}
            progressPending={commentModerationFilterLoading}
            data={tableData}
            noDataComponent={<div className="p-4 text-center text-gray-500">No comments available for this poll.</div>}
            paginationPerPage={perPage}
            pagination
            paginationServer
            onChangePage={handlePageChange}
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            paginationComponentOptions={{ noRowsPerPage: true }}
            paginationResetDefaultPage={resetPaginationToggle} 
            highlightOnHover
            responsive
          />
        </div>
      }
    </div>
  )
}

export default CommentModeration;